const isElementVisible = (el, wrapper) => {
  const elRect = el.getBoundingClientRect();
  const wrapperRect = wrapper.getBoundingClientRect();

  return elRect.top >= wrapperRect.top && elRect.bottom <= wrapperRect.bottom;
};

export default isElementVisible;



// WEBPACK FOOTER //
// ./src/utils/isElementVisible.js